import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import addressesReducer from './features/addressesSlice';
import browserReducer from './features/browserSlice';
import productReducer from './features/productSlice';
import cartReducer from './features/cartSlice';
import instantCheckoutReducer from './features/instantCheckoutSlice';

const rootReducer = combineReducers({
  instantCheckout: instantCheckoutReducer,
  addresses: addressesReducer,
  browser: browserReducer,
  product: productReducer,
  cart: cartReducer,
});

const persistConfig = {
  key: 'affilio',
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
